<template>
  <a-dialog
    ref="dialog"
    name="delete_api_token"
    :loading="loading"
    size="small"
    @open="opened"
    @close="$reset"
  >
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('text') }}
    </div>
    <span slot="actions">
      <v-btn color="blue darken-1" text @click="submit">
        {{ $t('actions.remove') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'ApiTokenCreatedDialog',
  data () {
    return {
      id: null,
      loading: ''
    }
  },
  methods: {
    opened ({ id }) {
      this.id = id
    },
    async submit () {
      this.loading = this.$t('loading')
      try {
        await this.$api.delete('account/tokens/api/' + this.id)
        this.$ui.success(this.$t('success'))
        if (this.$refs.dialog) this.$refs.dialog.close()
        this.$bus.emit('refresh_api_token_table')
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"loading": "Deleting token ...",
		"success": "The token has been successfully deleted.",
		"text": "Are you sure you want to delete this token? Its access will be permanently revoked.",
		"title": "Token deletion"
	},
	"es": {
		"loading": "Eliminando token ...",
		"success": "El token se ha eliminado correctamente.",
		"text": "¿Está seguro de que desea eliminar este token? Su acceso será revocado definitivamente.",
		"title": "Eliminación de token"
	},
	"fr": {
		"loading": "Suppression du token ...",
		"success": "Le token a été supprimé avec succès.",
		"text": "Êtes-vous sûr de vouloir supprimer ce token ? Son accès sera définitivement révoqué.",
		"title": "Suppression du token"
	},
	"it": {
		"loading": "Eliminazione del token ...",
		"success": "Il token è stato eliminato con successo.",
		"text": "Sei sicuro di voler eliminare questo token? Il suo accesso verrà revocato definitivamente.",
		"title": "Eliminazione del token"
	},
	"pt": {
		"loading": "A eliminar token ...",
		"success": "O token foi eliminado com sucesso.",
		"text": "Tem a certeza de que deseja eliminar este token? O seu acesso será revogado definitivamente.",
		"title": "Eliminação do token"
	},
	"pl": {
		"loading": "Usuwanie tokenu ...",
		"success": "Token został pomyślnie usunięty.",
		"text": "Czy na pewno chcesz usunąć ten token? Jego dostęp zostanie trwale odwołany.",
		"title": "Usunięcie tokenu"
	}
}
</i18n>

